import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		teilnehmer: '',
		lesezeichenListe: [],
		lesezeichenTitelListe: [],
		suchKriterien: {
			lesezeichenAnzeigen: Number,
			filterStatus: [],
			filterBox: [],
			filterFacette: [],
			verfahrenSuchbegriff: '',
			sortierungKriterium: '',
			sortierungReihenfolge: ''
		}
	},
	mutations: {
		setTeilnehmer(state, kennung) {
			state.teilnehmer = kennung;
			localStorage.setItem('teilnehmer', kennung);
		},
		resetTeilnehmer(state) {
			state.teilnehmer = '';
			localStorage.removeItem('teilnehmer');
		},
		async getLesezeichenListe(state) {
			// Lesezeichen holen und speichern
			try {
				const response = await axios.get('https://www.arbeitsverdichtung.de/api/lesezeichenliste', {
					params: {
						teilnehmer: state.teilnehmer
					}
				});
				const data = await response;
				var result = data.data;
				// Lesezeichenliste leeren und neu befüllen
				state.lesezeichenListe.splice(0);
				state.lesezeichenTitelListe.splice(0);
				result.forEach(element => {
					state.lesezeichenListe.push(element.verfahrenid);
					state.lesezeichenTitelListe.push(element);
				});
			} catch (error) {
				alert(error);
			}
		},
		setSuchKriterien(state, kriterien) {
			state.suchKriterien.lesezeichenAnzeigen = kriterien.lesezeichenAnzeigen;
			state.suchKriterien.filterStatus = kriterien.filterStatus;
			state.suchKriterien.filterBox = kriterien.filterBox;
			state.suchKriterien.filterFacette = kriterien.filterFacette;
			state.suchKriterien.verfahrenSuchbegriff = kriterien.verfahrenSuchbegriff;
			state.suchKriterien.sortierungKriterium = kriterien.sortierungKriterium;
			state.suchKriterien.sortierungReihenfolge = kriterien.sortierungReihenfolge;
		}
	},
	actions: {
		setTeilnehmer(state, kennung) {
			state.commit('setTeilnehmer', kennung);
		},
		resetTeilnehmer(state) {
			state.commit('resetTeilnehmer');
		},
		getLesezeichenListe(state) {
			state.commit('getLesezeichenListe');
		},
		setSuchKriterien(state, suchKriterien) {
			state.commit('setSuchKriterien', suchKriterien);
		}		
	},
	getters: {
		currentTeilnehmer(state) {
			return state.teilnehmer;
		},
		getSuchKriterien(state) {
			return state.suchKriterien;
		},
	}
});
